export default __webpack_public_path__ + "static/media/carbondioxide.7df3236a.svg";